/* eslint-disable max-len */
import _find from 'lodash/find.js';
import {
  START_REMOVE_ITEM_FROM_BUNDLE,
  INITIATE_ADD_ITEM_TO_BUNDLE,
  CREATE_PURCHASED_LOGO_FAILED,
  ADD_LIQUIDPIXEL_LOGO_FAILS,
  UPDATE_CURRENT_ITEM_QUANTITY,
  COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY,
  ADD_ITEM_TO_ORDER_SUMMARY_FAILED,
  REMOVE_ITEM_IN_BUNDLE_FROM_STORE,
  SET_LINE_ITEM_PRICE,
  COMPLETE_LIQUIDPIXEL_UPDATED_LOGO,
  LINE_ITEM_NOT_TO_BE_REMOVED,
  ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED,
  CREATE_ORDER_LINEITEM_LOGO_FAILED,
  SKU_EXISTS,
} from '../actions/orderSummaryActions/actionTypes';
import {
  CREATE_DESIGN_FAILED,
  CREATE_ITEM_FAILED,
  CREATE_ITEM_PRODUCT_FAILED,
  CREATE_CONFIG_FAILED,
  REMOVE_ITEM_FROM_DESIGN_FAILED,
  CREATE_ITEM_PRODUCT_SUCCESS,
} from '../actions/designActions/actionTypes';
import { 
  CART_SAVE_FAILED,
  CART_SAVE_SUCCESS,
  APP_MOUNT,
  GET_PRICING_ERROR,
  PRICING_AVAILABLE } from '../actions/actionTypes';

import {
  showSuccessToast,
} from '../components/orderSummary/OrderSummaryToast';
import { trackItemInteractions } from '../utils/analytics/trackEvents';

export const initialState = {
  currentItemQuantity: 1,
  isDeleting: false,
  loading: false,
  orderSummaryItems: [],
  dirty: false,
  bundleFailed: false,
  NotRemoveAfterMerge: false,
  isLiquidUrlfailed: false,
  isSkuExistBefore: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_MOUNT: {
      return {
        ...initialState,
      };
    }
    case INITIATE_ADD_ITEM_TO_BUNDLE: {
      return {
        ...state,
        loading: true,
      };
    }

    case ADD_LIQUIDPIXEL_LOGO_FAILS:  {
      return {
      ...state,
      isLiquidUrlfailed: action.error,
      }
    }
  

    case ADD_PREV_LOGO_TO_NEWLINEITEM_FAILED:
    case CREATE_ORDER_LINEITEM_LOGO_FAILED:
    case CREATE_PURCHASED_LOGO_FAILED: {
      return {
      ...state,
      bundleFailed: action.error,
      }
    }
    case LINE_ITEM_NOT_TO_BE_REMOVED: {
      return {
        ...state,
        NotRemoveAfterMerge: action.payload.truthy,
      }
    }
    case START_REMOVE_ITEM_FROM_BUNDLE: {
      return {
        ...state,
        isDeleting: true,
        bundleFailed: false,
        isLiquidUrlfailed: false,
        isSkuExistBefore: false,
      };
    }
    case PRICING_AVAILABLE: {
      return {
        ...state,
        isDeleting: false,
      };
    }
    case REMOVE_ITEM_IN_BUNDLE_FROM_STORE: {
      const itemsToKeep = state.orderSummaryItems.filter(item => item.id !== action.payload.id);
      const removedItem = state.orderSummaryItems.filter(item => item.id === action.payload.id);
      trackItemInteractions('button submission', 'bundle remove', removedItem);
      return {
        ...state,
        orderSummaryItems: itemsToKeep,
        dirty: itemsToKeep.length > 0,
      };
    }
    case UPDATE_CURRENT_ITEM_QUANTITY: {
      return {
        ...state,
        currentItemQuantity: action.payload.newQuantity,
      };
    }
    case COMPLETE_ADD_ITEM_TO_ORDER_SUMMARY: {
      return {
        ...state,
        orderSummaryItems: [
          ...state.orderSummaryItems,
          action.payload.newItem,
        ],
        dirty: true,

      };
    }

    case GET_PRICING_ERROR:
    case CREATE_DESIGN_FAILED:
    case CREATE_ITEM_FAILED:
    case CREATE_ITEM_PRODUCT_FAILED:
    case CREATE_CONFIG_FAILED:
    case REMOVE_ITEM_FROM_DESIGN_FAILED:
    case CART_SAVE_FAILED:
    case CART_SAVE_SUCCESS:
    case ADD_ITEM_TO_ORDER_SUMMARY_FAILED: {
      return {
        ...state,
        loading: false,
        bundleFailed: false,
        isLiquidUrlfailed: false,
      };
    }
    case SET_LINE_ITEM_PRICE: {
      if (state.orderSummaryItems.length === 0) {
        return state;
      }

      const lastItem = state.orderSummaryItems[state.orderSummaryItems.length - 1];
      let orderSummaryItems = [];
      let isAdd = false;
      const {
        tieredPricing,
        strikeThroughPricing,
      } = action.payload;
      if (!lastItem.pricingId) { // new item getting added
        isAdd = true;
        orderSummaryItems = state.orderSummaryItems.length <= 1 ? [] :
          state.orderSummaryItems.slice(0, state.orderSummaryItems.length - 1);
        orderSummaryItems.push({
          ...lastItem,
          pricingId: tieredPricing[tieredPricing.length - 1].uniqueidentifier,
        });
        const matchingPrice = _find(tieredPricing, price => price.uniqueidentifier === tieredPricing[tieredPricing.length - 1].uniqueidentifier);
        const matchingFirstTier = _find(strikeThroughPricing, price => price.uniqueIdentifier === matchingPrice.uniqueidentifier);
        const trackItem = {
          ...lastItem,
          retail: matchingPrice.retail,
          // base = Unit Retail Price (e.g. $500 / qty 5 = $100 per unit)
          base: (matchingPrice.retail / matchingPrice.quantity).toFixed(2),
          firstTierRetail: matchingFirstTier.retail * lastItem.quantity,
          firstTierBase: matchingFirstTier.retail,
          costKey: matchingPrice.key,
          unit: matchingPrice.unit,
        };
        trackItemInteractions('button submission', 'bundle add', [trackItem]);
      } else { // repricing bundle - probably removed an item
        orderSummaryItems = [...state.orderSummaryItems];
      }

      // update new prices
      const newOrderSummaryItems = orderSummaryItems.map((item) => {
        const matchingPrice = _find(tieredPricing, price => price.uniqueidentifier === item.pricingId);
        const matchingFirstTier = _find(strikeThroughPricing, price => price.uniqueIdentifier === matchingPrice.uniqueidentifier);
        return {
          ...item,
          retail: matchingPrice.retail,
          // base = Unit Retail Price (e.g. $500 / qty 5 = $100 per unit)
          base: (matchingPrice.retail / matchingPrice.quantity).toFixed(2),
          firstTierRetail: item.firstTierRetail ?? matchingFirstTier.retail * item.quantity,
          firstTierBase: item.firstTierBase ?? matchingFirstTier.retail,
          costKey: matchingPrice.key,
          unit: matchingPrice.unit,
        };
      });
      if (isAdd) {
        showSuccessToast();
      }
      return {
        ...state,
        loading: false,
        orderSummaryItems: newOrderSummaryItems,
      };
    }
    case CREATE_ITEM_PRODUCT_SUCCESS: {
      return {
        ...state,
        dirty: false,
      };
    }
    case COMPLETE_LIQUIDPIXEL_UPDATED_LOGO: {
      if (state.orderSummaryItems.length === 0) {
        return state;
      }
      const lastItem = state.orderSummaryItems[state.orderSummaryItems.length - 1];
      let orderSummaryItems = [];
      orderSummaryItems = state.orderSummaryItems.length <= 1 ? [] :
      state.orderSummaryItems.slice(0, state.orderSummaryItems.length - 1);
      // const urlKeys  = Object.keys(action.payload.returnUrls);
      // let isValidUrls = urlKeys.length > 0;
        orderSummaryItems.push({
          ...lastItem,
          s3LiquidPixelUrl: action.payload.returnUrls,
        });


      return {
        ...state,
        orderSummaryItems,
      };
    }
    case SKU_EXISTS: {
      return {
        ...state,
        isSkuExistBefore: action.payload.data,
      }
    }
    default:
      return state;
  }
};
